module.exports = __webpack_public_path__ + "3782618412ac7521b70c19ff2b203bbb.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/vibo_logo.svg
// module id = 1381
// module chunks = 16